import {CashBackStatus} from '../api/getCashBackCards/cashBackCards.types';

export const calculateCashBackActiveCredit = (
  status: CashBackStatus,
  amount: number,
  used_amount: number,
  reserved_amount: number,
): number => {
  return status === CashBackStatus.Active
    ? calculateCashBackRestCredits(amount, used_amount, reserved_amount)
    : 0;
};

export const calculateCashBackRestCredits = (
  amount: number,
  used_amount: number,
  reserved_amount: number,
): number => {
  return amount - used_amount - reserved_amount;
};

export const calculateCashBackUsedCredits = (
  used_amount: number,
  reserved_amount: number,
): number => {
  return used_amount + reserved_amount;
};
